import './ItemNoteCard.css';

import { MoreVert, Star, Wysiwyg } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { truncateText } from '../../../b2b-common/helpers';
import IconWithTooltip from '../../../b2b-common/IconWithTooltip';
import MoreButton from '../../../b2b-common/MoreButton';
import ConfirmationDialog from '../../../b2b-common/ConfirmationDialog';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const ItemNoteCard = ({ item, onClick, onEdit, onDelete }) => {

    const { t } = useB2BTranslation('b2b-logbook');

    const [currentItem, setCurrentItem] = useState(item);
    const [isHovered, setIsHovered] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    useEffect(() => {
        setCurrentItem(item);
    }, [item]);

    const handleClick = () => {
        onClick && onClick(currentItem);
    }

    const handleEdit = () => {
        onEdit && onEdit(currentItem);
    }

    const handleDelete = () => {
        onDelete && onDelete(currentItem);
        setShowDeleteConfirmation(false);
    }

    return (
        <div className='note-item-card-container'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleClick}
        >
            <div className='note-item-card-icon-name'>
                <Wysiwyg />
                <div className='note-item-card-name'>
                    {currentItem.logBookItemName}
                </div>
            </div>
            <div className='note-item-card-info'>
                <div className='note-item-card-description'>
                    {truncateText(currentItem.logBookItemDescription, 20)}
                </div>
            </div>
            {currentItem.logBookItemStarred && (
                <IconWithTooltip IconComponent={Star} tooltip={t('Starred')} className='note-item-card-star' />
            )}
            {isHovered && (
                <MoreButton icon={<MoreVert />} className={'note-item-card-more-button'}
                    dropPositionAlign='right'
                    buttons={[
                        {
                            label: t('Edit'),
                            onClick: handleEdit,
                        },
                        {
                            label: t('Delete'),
                            onClick: () => setShowDeleteConfirmation(true),
                        }
                    ]}
                    rolesAllowed={['ADMIN', 'EDITOR']}
                    b2bProducts={['B2B_LOGBOOK']}
                />
            )}
            <ConfirmationDialog
                title={t('Note Delete Confirmation Request')}
                mainText={t('Are you sure you want to delete this note?')}
                open={showDeleteConfirmation}
                onClose={() => setShowDeleteConfirmation(false)}
                onConfirm={handleDelete}
            />
        </div>
    );
}

export default ItemNoteCard;